import { Directive, HostBinding } from '@angular/core';
import { clsx } from 'clsx';

@Directive({
  selector: '[chapterSubtitle]',
})
export class ChapterSubtitleDirective {
  @HostBinding('class')
  hostClasses = clsx('m-0 text-base font-bold uppercase');
}
